import {IEmailListData} from 'src/shared/services/configuration/email/dtos/email-list';

export const Email = (data: IEmailListData) => {
  return {
    Label: data.Email,
    Value: data.Id,
  };
};
